export default "/WebApp/dist/assets/images/clouds.jpg";